/**
 * en-GB messages added by Phase 3 task S23 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s23EnGB = {
    'nav.safety_check': 'Safety check',
};
//# sourceMappingURL=s23.js.map